import { Mobile, TRANSITION_END, Carousel_CoreInit, Form_CoreInit, Accordion, Scrollbar, Navigation } from './core'
import Episode from './modules/episode'
import Vh from './modules/vh'
import './modules/header'
import './plugins/sound-row'
import './plugins/coup-de-coeur'
import './plugins/page-header'
import './plugins/format-en-bref'
import './plugins/format-opportunite'
import './plugins/newsletter-form'
import './plugins/login-form'
import './plugins/infinite-scroll'
import './plugins/content-filters'
import './plugins/rolling-banner'
import './plugins/drawer'

function VR_InitializeScripts(scope) {
  /* Make sure vh works on ios */
  Vh.init()

  /* Shuffle territory slides */
  let territorySlider = $('.grid--postitem__territory.grid--style--carrousel-menu')
  if (territorySlider.length) {
    let territorySlides = territorySlider.children()
    while (territorySlides.length) {
      territorySlider.append(territorySlides.splice(Math.floor(Math.random() * territorySlides.length), 1)[0]);
    }
  }

  /* Forms */
  Form_CoreInit([
    {
      classSelector: 'builder-form--contact',
      formOptions: {
        floating_labels: true
      }
    }
  ])

  $('.single-content .related-content .carousel--postitem__content').addClass('--related-content-carousel');
  $('.expertise-article .related-content .carousel--postitem__expertise_article').addClass('--related-content-carousel');
  Carousel_CoreInit([
    {
      classSelector: 'layout--layout3',
      swiperOptions: {
        breakpoints: {
          0: {
            slidesPerView: 'auto',
          },
        },
      },
    },
    {
      classSelector: 'layout--layout4',
      swiperOptions: {
        breakpoints: {
          0: {
            slidesPerView: 'auto',
          },
        },
      },
    },
    {
      classSelector: 'layout--landscape_1_car',
      swiperOptions: {
        loop: true,
        loopAdditionalSlides: 4,
      },
    },
    {
      classSelector: '--related-content-carousel',
      swiperOptions: {
        on: {
          beforeInit: function (swiper) {
            if ($.mlmi.mobile.isMobile) {
              $(this.$el).find('.grid__item').each(function(index) {
                if ((index + 1)%2 == 0) {
                  $(this).addClass('--hidden')
                } else {
                  if ($(this).find('a').length < 2) {
                    $(this).append($(this).next('.grid__item').find('a').clone().addClass('--clone'));
                  }
                }
              });
            } else {
              $(this.$el).find('.--clone').remove();
              $(this.$el).find('.--hidden').removeClass('--hidden');
            }
          },
        },
      },
    },
    {
      classSelector: 'carousel--style--carrousel-menu',
      swiperOptions: {
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet: function (index, className) {
            var title = $(this.$el).find('.swiper-slide').eq(index + 1).find(".card-carrousel-menu__title").html();
            return '<span class="' + className + '"><span class="bullet-title">' + title + "</span></span>";
          },
        },
        on: {
          activeIndexChange: function (swiper) {
            var active = swiper.activeIndex
            let container = $(this.$el).find('.swiper-pagination-wrapper')
            if (container.length > 0) {
              if (active > container.find('.swiper-pagination-bullet').length) {
                active = 1;
              }
              var max_offset = container.attr('data-width') - $(window).width() + 60;
              var new_element = container.find('.swiper-pagination-bullet:nth-child(' + active + ')')

              //create dummies
              var dummies = new_element.siblings().not(new_element.next()).clone().addClass('dummie').removeClass('swiper-pagination-bullet-active')
              $(this.$el).find('.swiper-pagination').append(dummies);

              var offset = new_element.offset().left + container.offset().left * -1
              container.addClass('--animate');
              if (offset < 0) {
                container.css('transform', 'translateX(0px)')
              } else {
                container.css('transform', 'translateX(-' + offset + 'px)')
              }
              var menu_list = $(this.$el).find('.swiper-pagination');

              const myTimeout = setTimeout(function() {
                container.removeClass('--animate');
                var current_level = parseInt(new_element.css('order'))
                new_element.prevAll().css('order', current_level + 1);
                new_element.nextAll().css('order', current_level);
                container.find('.dummie').remove()
                container.css('transform', 'translateX(0px)')
                clearTimeout(myTimeout);
              }, 300);
            }
          },
          init: function(swiper) {
            let menu_width = 0;
            $(this.$el).find('.swiper-pagination-bullet').each(function(){
              menu_width += $(this).innerWidth();
            })
            var available_space = $(window).width() - menu_width - 60
            if (available_space > 0) {
              available_space = available_space / $(this.$el).find('.swiper-pagination-bullet').length
              $(this.$el).css('--available-space', available_space + 'px');
            }
            $(this.$el).find('.swiper-pagination').wrap('<div class="swiper-pagination-wrapper">')
            var container = $(this.$el).find('.swiper-pagination-wrapper');
            container.css('width', '9999vw');
            container.attr('data-width', $(this.$el).find('.swiper-pagination').width())
            container.css('width', '100%');
            container.css('transform', 'translateX(0)')
          },
          resize: function(swiper) {
          }
        },
      },
    },
  ])

  /* Contenu - En bref */
  scope.find('.Vswiper').each(function() {
    $.mlmi.vswiper = $(this).verticalPageSwiper()
  })

  /* Contenu - Opportunité */
  scope.find('.content--format-opportunite').each(function() {
    $(this).Opportunite()
  })

  /* Media players */
  Episode.init()

  /* Accordions */
  Accordion.init()

  /* Sound row */
  scope.find('.sound-row, .accordion--balado .accordion__item, .featured-content-row').each(function() {
    let soundRow = $(this).SoundRow()
    $.mlmi.players.push(soundRow)
  })

  /* Coup de coeur */
  scope.find('.card-coup-de-coeur').each(function() {
    $(this).CoupDeCoeur()
  })

  /* Site header */
  scope.find('.header').each(function() {
    $(this).Header()
  })

  /* Page header carousel */
  scope.find('.page-header').each(function() {
    $(this).PageHeader()
  })

  scope.find('.card-carrousel-menu .video-loop, .featured-content-row .video-loop').each(function() {
    $(this).VideoLoop()
  })

  /* Share within page */
  scope.find('.content-share').each(function() {
    if ($('body').hasClass('--content-bar')) {
      $(this).ContentShare()
    }
  })

  /* Back to top */
  if (scope.find('.back-to-top').length) {
    let scrolledDown = false,
    topArrow = $('.back-to-top').BlockElement()
    scope.find('.back-to-top').on('click', function() {
      $.mlmi.scroller.scrollTo(0, 450, 4, 'easeInOutQuart')
    })
    $.mlmi.scroller.add(function(top, direction) {
      if (!scrolledDown && top > $(window).height() / 2) {
        scrolledDown = true
        topArrow.addModifier('visible')
      } else if (scrolledDown && top < $(window).height() / 2) {
        scrolledDown = false
        topArrow.removeModifier('visible')
      }
    })
  }

  /* Infinite scroll within formats */
  scope.find('.content__wrapper').each(function() {
    $.mlmi.infinite = $(this).InfiniteScroll({
      onLoad: function(content) {
        VR_InitializeScripts(content)
      },
    })
  })
  // scope.find('.Vswiper__wrapper').each(function() {
  //   $(this).InfiniteScroll({
  //     onLoad: function(content) {
  //       content.hide()
  //       let slides = content.find('.swiper-slide')
  //       $.mlmi.vswiper.getSwiper().appendSlide(slides)
  //       VR_InitializeScripts(slides)
  //     },
  //   })
  // })

  /* Content footer for En bref */
  // scope.find('.content--format-en-bref').each(function() {
  scope.find('.content').each(function() {
    $('.content-footer').InfiniteScroll_Footer().initialize()
  })

  /* Newsletter form */
  scope.find('.newsletter-form').each(function() {
    $(this).NewsletterForm()
  })

  scope.find('.user-form--login').each(function() {
    $(this).LoginForm()
  })

  scope.find('.js-newsletter-toggle').click(function() {
    $(this).closest('.content-footer__newsletter').addClass('--show-form');
  })

  scope.click(function(e) {
    if ($(e.target).closest('.content-footer__newsletter').length == 0) {
      $('.content-footer__newsletter').removeClass('--show-form');
    }
  });

  scope.find('.js-filtered-content').each(function() {
    $(this).ContentFilters()
  })

  scope.find('.content-filter').each(function() {
    $(this).Drawer({
      toggle: '.content-filter__title',
      content: '.content-filter__list'
    })
  })

  scope.find('.fade-in, .slide-in').each(function() {
    $(this).FadeIn()
  })

  scope.find('.text-content figure, .--small-overlay, .--big-overlay').click(function() {
    $(this).toggleClass('--hover')
  });

  scope.find('[data-fancybox]').fancybox({
    hash: false,
    backFocus: false,
  })

  scope.find('.format-menu').each(function() {
    let content_results = new Scrollbar($(this), {
      direction: 'horizontal',
      desktop: false,
      mobile: true,
    })
  })

  scope.find('.banner').each(function() {
    $(this).RollingBanner()
  })
}

$(function() {
  $.mlmi = {
    mobile: new Mobile(),
    burger: undefined,
    players: [],
    scroller: $('.app').ScrollEvents(),
    vswiper: undefined,
    infinite: undefined,
    navigation: undefined,
  }

  $.mlmi.navigation = new Navigation({
    useTransition: false,
    selectors: {
      links: false,
    },
    filter: {
      popState: function(stateObject, action) {
        if ($.mlmi.infinite != undefined && $.mlmi.infinite.current_content != undefined && $.mlmi.infinite.current_content.json_ld != undefined) {
          $.mlmi.navigation.replaceMeta($.mlmi.infinite.current_content.json_ld)
        }
        return stateObject
      },
    }
  })

  VR_InitializeScripts($('body'))
});
